
import { Modal } from '@mantine/core';
import PrimaryButton from './PrimaryButton';
import SecondaryButton from './SecondaryButton';

function StartOverModal({
  onStartOver,
  opened,
  close,
  message ="Are you sure you want to start over?",
  onCancel = close,
}: {
  onStartOver: () => void;
  onCancel: () => void;
  opened: boolean;
  close: () => void;
  message?: string;
}) {
  

  return (
    <>
      <Modal opened={opened} onClose={close} title="Start Over" centered>
        <div className="flex flex-col items-center justify-center gap-4">
          <p className="text-sm text-gray-500">{message}</p>
          <div className="flex flex-row items-center justify-center gap-4">
            <SecondaryButton onClick={
              onCancel || close
            }>Cancel</SecondaryButton>
            <PrimaryButton text="Start Over" onClick={onStartOver} classNames="h-[2px] md:w-auto" />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default StartOverModal;